<div class="wrapper" #wrapper>
    <h1>{{Name}}</h1>
    <div class="message">
        <p *ngIf="showConnecting">verbinden</p>
        <p *ngIf="showWaitingForPartner">Warten auf Partner</p>
        <p *ngIf="showWaitingForTransmission">Warten auf Übertragung</p>
    </div>
    <video #local class="local" autoplay playsinline muted></video>
    <video #remote class="remote" autoplay playsinline (pause)="RemoteVideoPaused()"></video>
    <div class="buttons">
        <div>
            <button mat-mini-fab color="primary" [matMenuTriggerFor]="settings" [disabled]="!Running">
                <fa-icon icon="cog"></fa-icon>
            </button>
            <button mat-fab color="primary" *ngIf="(Settings |async).AllowClientShoot && Running" (click)="TakePhoto()">
                <fa-icon icon="camera"></fa-icon>
            </button>
            <div class="placeholder" *ngIf="!(Settings |async).AllowClientShoot || !Running"></div>
            <div class="placeholder"></div>
        </div>
    </div>
</div>

<mat-menu #settings="matMenu">
    <button mat-menu-item [matMenuTriggerFor]="speakers" *ngIf="SpeakerSetEnabled">
        <fa-icon icon="volume-up"></fa-icon>
        <span>Lautsprecher</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="microphones">
        <fa-icon icon="microphone"></fa-icon>
        <span>Mikrofon</span>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="cameras">
        <fa-icon icon="camera"></fa-icon>
        <span>Kamera</span>
    </button>

    <!--<button mat-menu-item (click)="Test()">
        <span>TEST</span>
    </button>-->
</mat-menu>

<mat-menu #speakers="matMenu">
    <button mat-menu-item *ngFor="let s of (Speakers$|async)" (click)="SetSpeaker(s.deviceId)" [disabled]="s.deviceId == CurrentSpeakerId">
        {{s.label}}
    </button>
</mat-menu>

<mat-menu #microphones="matMenu">
    <button mat-menu-item *ngFor="let m of (Microphones$|async)" (click)="SetMicrophone(m.deviceId)" [disabled]="m.deviceId == CurrentMicrophoneId">
        {{m.label}}
    </button>
</mat-menu>

<mat-menu #cameras="matMenu">
    <button mat-menu-item *ngFor="let c of (Cameras$|async)" (click)="SetCamera(c.deviceId)" [disabled]="c.deviceId == CurrentCameraId">
        {{c.label}}
    </button>
</mat-menu>
